import { useState } from "react";
import { getQueryParam, updateQueryParam } from "shared/lib";
import { useDebouncedTableFilter } from "./useDebouncedTableFilter";

export const useProcessStepTableFilters = () => {
  const {
    debouncedValue: debouncedNameContains,
    handleFilterChange: handleNameContainsValue,
    value: nameContainsValue,
    clearFilterValue: clearNameContainsValue,
  } = useDebouncedTableFilter("Name", 400);

  const {
    debouncedValue: debouncedInputMaterial,
    handleFilterChange: handleInputMaterialValue,
    value: inputMaterialValue,
    clearFilterValue: clearInputMaterialValue,
  } = useDebouncedTableFilter("InputMaterial", 400);

  const {
    debouncedValue: debouncedOutputMaterial,
    handleFilterChange: handleOutputMaterialValue,
    value: outputMaterialValue,
    clearFilterValue: clearOutputMaterialValue,
  } = useDebouncedTableFilter("OutputMaterial", 400);

  const initialProcessTemplate = getQueryParam("processTemplate");
  const [processTemplateFilter, setProcessTemplateFilter] = useState<
    number | string
  >(initialProcessTemplate || "");

  const handleProcessTemplateFilter = (value: number | string) => {
    setProcessTemplateFilter(value);
    updateQueryParam("processTemplate", value.toString());
  };

  const clearProcessTemplateFilter = () => {
    setProcessTemplateFilter("");
    updateQueryParam("processTemplate");
  };

  const clearAllFilters = () => {
    clearNameContainsValue();
    clearInputMaterialValue();
    clearOutputMaterialValue();
    clearProcessTemplateFilter();
  };

  const isVisibleClearFiltersButton =
    !!debouncedNameContains ||
    !!debouncedInputMaterial ||
    !!debouncedOutputMaterial ||
    !!processTemplateFilter;

  return {
    debouncedNameContains,
    handleNameContainsValue,
    nameContainsValue,
    clearNameContainsValue,

    debouncedInputMaterial,
    handleInputMaterialValue,
    inputMaterialValue,
    clearInputMaterialValue,

    debouncedOutputMaterial,
    handleOutputMaterialValue,
    outputMaterialValue,
    clearOutputMaterialValue,

    processTemplateFilter,
    handleProcessTemplateFilter,
    clearProcessTemplateFilter,
    clearAllFilters,
    isVisibleClearFiltersButton,
  };
};
